import React from 'react';
import { useHistory } from 'react-router-dom';

import { ListItemIcon, SvgIconProps, Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { toKebabCase } from '@uplift/utils';

import { ClosableMenuItem } from '../../../../lib/simple-menu/closable-menu.component';

const CustomListItemIcon = withStyles(ListItemIcon, theme => ({
  root: {
    minWidth: 'auto',
    marginRight: theme.spacing(1),
  }
}));


export type NavigationProfileMenuItemBaseProps = {
  label: string;
  icon: React.ComponentType<SvgIconProps>;
};


export type NavigationProfileMenuItemProps = NavigationProfileMenuItemBaseProps & {
  onClick: () => void;
};


export const NavigationProfileMenuItem: React.FC<NavigationProfileMenuItemProps> = React.forwardRef(({ label, onClick, icon: Icon }, ref) => {
  return (
    <ClosableMenuItem dense onClick={onClick} ref={ref as any} data-testid={`nav-profile-menu-item-${toKebabCase(label)}`}>
      <CustomListItemIcon>
        <Icon />
      </CustomListItemIcon>
      <Typography color="textPrimary">{label}</Typography>
    </ClosableMenuItem>
  );
});


export type NavigationProfileMenuItemLinkProps = NavigationProfileMenuItemBaseProps & {
  path: string;
};


export const NavigationProfileMenuItemLink: React.FC<NavigationProfileMenuItemLinkProps> = ({ path, ...props }) => {
  const history = useHistory();

  return (
    <NavigationProfileMenuItem
      {...props}
      onClick={() => history.push(path)}
    />
  );
};
